import { underlineLinkStyle } from './shared-styles-from-theme-fluent';

export const crudKeywordStyle = ({ palette = {} }) => ({
  '& .add-keywords-root': {
    marginLeft: '32px',
    marginTop: '24px',
    '& .create-keywords-errors .error': {
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      width: 320,
      marginLeft: 10,
    },
    '& .panel-heading': {
      padding: 0,
      '& .panel-title': {
        fontSize: '20px',
        fontWeight: 600,
      },
    },
    '& .panel-body': {
      padding: '0px 0px 0px 0px',
      '& .displayNone': {
        display: 'none',
      },
      '& .col-sm-4': {
        paddingLeft: 0,
        marginTop: '32px',
        '& .ba-campaign-adgroup-selector': {
          '& .dropdown-toggle': {
            width: '330px',
            '& .selected-item': {
              maxWidth: '280px',
            },
          },
          '& .list-selector-content': {
            height: 390,
          },
        },
        '& #Keyword_EnterKeywords_Label, & .helpbutton': {
          display: 'inline-block',
        },
        '& textarea': {
          width: '330px',
        },
        '& p': {
          width: '330px',
          ...underlineLinkStyle({ palette, elementLocator: ' > a.HelpTopic' }),
        },
        '& .alert': {
          width: '330px',
          ...underlineLinkStyle({ palette, elementLocator: ' a.HelpTopic' }),
        },
      },
      '& .row': {
        margin: 0,
        '& .bid-section__container .form-group': {
          margin: 0,

          '& .input-group': {
            width: '330px',

            '& .bidlandscape_icon': {
              position: 'absolute',
              top: '50%',
              transform: 'translate(-23px, -50%)',
              cursor: 'pointer',
              zIndex: 3,
            },
          },
        },
      },
      '& .row.buttons-row': {
        paddingTop: '16px',
        paddingBottom: '16px',
      },
    },
    '& #KoErrors': {
      display: 'block',
      lineHeight: '21px',
    },
    '& .create-keywords-panel__errors': {
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      width: 330,
    },
  },
});
